<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">合同支付进度款审核意见单</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn"
        >返回合同详情</a
      >
    </div>
    <div class="form-content" v-if="contract.name">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="140px" class="form">
          <create-money-approval
            ref="create"
            :contract="contract"
            :userData="userData"
            :formByFather="form"
          ></create-money-approval>

          <div class="tip" style="margin: 20px 0 0 40px">* 相关附件</div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments
                :projectId="form.projectId"
                :contractId="form.contractId"
                ref="attachments"
                :arr="attachmentArr"
                :type="5"
              ></attachments>
            </el-form-item>
          </div>

          <div class="tip" style="margin: 20px 0 0 40px">* 意见与审批</div>
          <div class="clear label-mx">
            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <approval-item
              ref="approval"
              :approvalUsers="approvalUsers.c33"
              :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"
            ></approval-item>
          </div>

          <el-form-item label="">
            <div class="form-btn-room">
              <el-button
                :loading="formLoading"
                @click="createProject()"
                class="form-btn"
                type="success"
                >确认提交项目进度款审核意见单</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Attachments from "@/components/Attachments";
import approvalUsers from "@/Mixins/approvalUsers";

import ApprovalItem from "../../components/ApprovalItem";
import CreateMoneyApproval from "../form/createMoneyApproval";
export default {
  components: {
    ApprovalItem,
    CreateMoneyApproval,
    Attachments,
  },
  mixins: [approvalUsers],
  computed: {
    ...mapState({
      userData: (state) => state.main.userData,
    }),
  },
  data() {
    return {
      contract: {},
      form: {
        contractId: "",
        sstime: "",

        jbzf: "0,0,0,0",
        azf: "0,0,0,0",
        bxfxm: "0,0,0,0",
        zlj: "0,0,0,0",
        gcbg: "0,0,0,0",
        jgtz: "0,0,0,0",
        gcyfk: "0,0,0,0",
        xj: "0,0,0,0",
        kkxm: "0,0,0,0",
        hkgcyfk: "0,0,0,0",
        blj: "0,0,0,0,5",
        yk: "0,0,0,0,20",
        sjzf: "0,0,0,0",

        // 是否线下审批通过
        underLine: "",
      },

      // 附件
      attachmentArr: [],
      // 审批
      approvalType: "0",
      formLoading: false,

      applyInfo: "",
    };
  },
  created() {
    this.getApplyData();
    // this.setSelectArr(this.applyInfo, 5)
  },
  mounted() {
    this.form.contractId = this.$route.params.contractId;
    this.form.sstime = util.getFormatDate();
    this.getProject();
  },
  methods: {
    // 获取审批表原内容
    getApplyData() {
      this.form.approvalId = this.$route.params.applyId;
      if (this.form.approvalId) {
        this.formLoading = true;
        this.getProjectApplyInfo();
      } else {
        this.setSelectArr(this.applyInfo, 33);
      }
    },
    // 获取原审批表内容
    getProjectApplyInfo() {
      ajax.get(
        "/gc/project/money/approval/info/" + this.form.approvalId,
        "",
        (res) => {
          this.applyInfo = res.vo;

          this.form.sstime = this.applyInfo.sstime;

          this.form.jbzf = this.applyInfo.jbzf;
          this.form.azf = this.applyInfo.azf;
          this.form.bxfxm = this.applyInfo.bxfxm;
          this.form.zlj = this.applyInfo.zlj;
          this.form.gcbg = this.applyInfo.gcbg;
          this.form.jgtz = this.applyInfo.jgtz;
          this.form.gcyfk = this.applyInfo.gcyfk;
          this.form.xj = this.applyInfo.xj;
          this.form.kkxm = this.applyInfo.kkxm;
          this.form.hkgcyfk = this.applyInfo.hkgcyfk;
          this.form.blj = this.applyInfo.blj;
          this.form.yk = this.applyInfo.yk;
          this.form.sjzf = this.applyInfo.sjzf;

          // 是否线下通过审批
          this.form.underLine = this.applyInfo.underLine.toString();

          this.attachmentArr = this.applyInfo.attachments
            ? this.applyInfo.attachments
            : [];

          this.setSelectArr(this.applyInfo, 33);
          this.formLoading = false;
        }
      );
    },
    // 获取所有项目
    getProject() {
      ajax.get("/contract/info/" + this.form.contractId, "", (res) => {
        this.contract = res.vo;
        this.contract.depId = this.contract.departmentVO.id;
        this.contract.deptName = this.contract.departmentVO.name;
      });
    },
    // 提交
    createProject() {
      this.form = this.$refs.create.getFromData();
      if (this.form.underLine == "") {
        this.$message.error("请标注本次审批是否已线下通过");
        return;
      }

      this.form.approvalType = this.approvalType;
      this.form.approvalUserIds = this.$refs.approval.getUserIds();
      this.form.attachments = this.$refs.attachments.getAttachments();

      this.formLoading = true;
      let _url = !this.form.approvalId
        ? "/gc/project/money/approval"
        : "/gc/project/money/approval/edit";

      ajax.post(
        _url,
        this.form,
        (res) => {
          this.$message.success(
            "提交项目进度款审核意见单成功，请耐心等待领导审批"
          );
          this.$router.back();
          this.formLoading = false;
        },
        (res) => {
          this.formLoading = false;
        }
      );
    },
  },
  watch: {},
};
</script>


// WEBPACK FOOTER //
// src/page/contract/createMoneyApproval.vue